import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    margin: 0 20px;
    padding: 20px 0;
    gap: 20px;
    flex-grow: 1;
    flex-direction: column;
`;

export const HeadWrapper = styled('div')`
    display: flex;
    gap: 24px;
    flex-direction: column;
`;

export const ContentWrapper = styled('div')`
    display: flex;
    gap: 30px;
    align-items: flex-start;
`;

export const Content = styled('div')`
    display: flex;
    max-width: 864px;
    gap: 20px;
    flex-grow: 1;
    flex-direction: column;
`;

export const Side = styled('div')`
    display: flex;
    width: 380px;
    flex-shrink: 0;
    flex-direction: column;
`;

export const TabWrapper = styled('div')`
    margin-top: 20px;
`;
